import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useConfirm } from 'material-ui-confirm'
import React, { FunctionComponent, useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { notSuccess } from '../../../../utils/notification'
import { swalClose, swalException } from '../../../../utils/swal'
import { apiGrupoUnidadMedidaRegistro } from '../../api/apiGrUniMedRegistro'
import {
  GRUPO_UNIDAD_MEDIDA_INITIAL_VALUES,
  GrupoUnidadMedidaInputProps,
  GrupoUnidadMedidaProp,
} from '../../interfaces'
import { grupoUnidadMedidaRegistroComposeService } from '../../services/grUniMedRegistroComposeService'
import {
  GrupoUnidadMedidaRegistroValidationSchema,
  grupoUnidadMedidaRegistroValidator,
} from '../../validator/grUniMedRegistro.validator'
import GrupoUnidadMedidaForm from '../GrUniMedForm'

interface OwnProps {
  id: string
  keepMounted: boolean
  open: boolean
  // eslint-disable-next-line no-unused-vars
  onClose: (value?: GrupoUnidadMedidaProp) => void
}

type Props = OwnProps

const GrupoUnidadMedidaRegistro: FunctionComponent<Props> = (props) => {
  const { onClose, open, ...other } = props

  const form = useForm<GrupoUnidadMedidaInputProps>({
    defaultValues: { ...GRUPO_UNIDAD_MEDIDA_INITIAL_VALUES },
    resolver: yupResolver<any, any, any>(GrupoUnidadMedidaRegistroValidationSchema),
  })

  interface Objeto {
    [key: string]: any
  }

  function filtrarArray(array: (Objeto | null)[]): Objeto[] {
    const arrayFiltrado: Objeto[] = []

    array.forEach((objeto) => {
      if (objeto !== null) {
        const objetoFiltrado: Objeto = {}

        for (const key in objeto) {
          if (Object.prototype.hasOwnProperty.call(objeto, key) && objeto[key] !== null) {
            objetoFiltrado[key] = objeto[key]
          }
        }

        arrayFiltrado.push(objetoFiltrado)
      }
    })

    return arrayFiltrado
  }

  const confirm = useConfirm()

  const onSubmit: SubmitHandler<GrupoUnidadMedidaInputProps> = async (values) => {
    const val = await grupoUnidadMedidaRegistroValidator(values)

    const codigoUnidadMedidaBase = values.codigoUnidadMedidaBase
    const arregloFiltrado: Objeto[] = filtrarArray(values.definicion)
    console.log(values.definicion)
    console.log(arregloFiltrado)
    const nuevaDefinicion = arregloFiltrado.map(
      ({ codigoUnidadMedida, cantidadBase }) => ({
        codigoUnidadMedida,
        cantidadBase,
      }),
    )

    const apiInput = grupoUnidadMedidaRegistroComposeService({
      nombreGrupo: values.nombreGrupo,
      codigoUnidadMedidaBase,
      definicion: nuevaDefinicion, // Enviamos solo las propiedades necesarias
    })

    const { confirmed } = await confirm()
    if (!confirmed) return
    const resp = await apiGrupoUnidadMedidaRegistro(apiInput).catch((e) => {
      swalException(e)
    })
    if (resp) {
      notSuccess('Registro exitoso')
      onClose(resp)
      swalClose()
    } else {
      swalClose()
    }
  }

  const onError = (errors: any, e: any) => console.log(errors, e)
  useEffect(() => {
    if (open) {
      form.reset({
        ...GRUPO_UNIDAD_MEDIDA_INITIAL_VALUES,
      })
    }
  }, [open])

  const queryClient = useQueryClient()

  const actualizarDatosGrupoUnidadMedida = () => {
    queryClient.invalidateQueries({
      queryKey: ['grupoUnidadMedidaListado'],
    })
  }

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: 700 } }}
      maxWidth="xl"
      open={open}
      {...other}
    >
      <DialogTitle>Nuevo Grupo Unidad de Medida</DialogTitle>
      <DialogContent dividers>
        <GrupoUnidadMedidaForm form={form} handleEdit={false} />
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          autoFocus
          color={'error'}
          size={'small'}
          onClick={() => {
            actualizarDatosGrupoUnidadMedida()
            onClose()
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={form.handleSubmit(onSubmit, onError)}
          size={'small'}
          style={{ marginRight: 25 }}
          variant={'contained'}
          // disabled={form.formState.isSubmitting}
        >
          Registrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default GrupoUnidadMedidaRegistro
